// extracted by css-extract-rspack-plugin
var _1 = "M3UPeoMvzszzrE67";
var _2 = "wKOfcdM5sJYFplxb";
var _3 = "KJzXWiLh5wgaVjgx";
export { _1 as "badgeBaseStyle", _2 as "labelStyle", _3 as "preserveTextSizeStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "M3UPeoMvzszzrE67";
var _2 = "wKOfcdM5sJYFplxb";
var _3 = "KJzXWiLh5wgaVjgx";
export { _1 as "badgeBaseStyle", _2 as "labelStyle", _3 as "preserveTextSizeStyle" }
